import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO, ESTATUS_CANCELADO, ESTATUS_ACTIVO } from 'utils/constants';

export const baseURI = '/catalogos/tipo-de-evaluacion-de-asistencia/';

/**
 * GET tipo de evaluacion de asistencia
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getEvaluacionesAsistencia = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET tipo de evaluacion de asistencia
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getEvaluacionAsistencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST tipo de evaluacion de asistencia
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postEvaluacionAsistencia = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH tipo de evaluacion de asistencia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchEvaluacionAsistencia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE tipo de evaluacion de asistencia
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteEvaluacionAsistencia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR tipo de evaluacion de asistencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarEvaluacionAsistencia = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * CANCELAR tipo de evaluacion de asistencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const cancelarEvaluacionAsistencia = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_CANCELADO });
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * REACTIVAR tipo de evaluacion de asistencia
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const reactivarEvaluacionAsistencia = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_ACTIVO });
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
